import { Mail } from "lucide-react";

const LABELS = {
  booking_confirmation: "Booking confirmation",
  appointment_reminder: "Appointment reminder",
  auto_form: "Form sent automatically",
  booking_form: "Form sent by provider",
  patient_form: "Legal document sent",
  form_reminder: "Form completion nudge",
  booking_cancelled: "Cancellation confirmation",
  reschedule_confirmation: "Reschedule confirmation",
  review_request: "Google review request",
  rebook_reminder: "Touch-up reminder",
  balance_nudge: "Banked balance update",
  gift_certificate: "Gift certificate",
  password_reset: "Password reset link",
};

const STATUS_STYLE = {
  sent: "border-forest/30 bg-forest/10 text-forest",
  failed: "border-destructive/30 text-destructive",
  skipped_rebooked: "border-linen text-moss",
  mocked: "border-linen text-moss",
};

function when(iso) {
  const d = new Date(iso);
  return `${d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })} · ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
}

export function PatientEmailLog({ emails }) {
  return (
    <section data-testid="patient-email-log" className="rounded-lg border border-linen bg-ivory p-5 lg:col-span-2">
      <div className="flex items-center gap-2">
        <Mail size={16} className="text-moss" />
        <h3 className="font-serif text-xl font-medium text-forest">Email activity</h3>
        <span className="ml-auto text-xs text-moss">{emails.length} total</span>
      </div>
      {emails.length === 0 ? <p className="mt-4 text-xs text-moss">No emails have been sent to this patient yet.</p> : (
        <ul className="mt-4 divide-y divide-linen text-sm">
          {emails.map((e, i) => (
            <li key={`${e.sent_at}-${i}`} data-testid={`email-log-row-${i}`} className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 py-2.5">
              <div>
                <p className="text-forest">{LABELS[e.type] || e.type}{e.form_name ? ` — ${e.form_name}` : ""}</p>
                <p className="text-xs text-moss">{when(e.sent_at)}{e.booking_label ? ` · ${e.booking_label}` : ""}{e.balance != null ? ` · $${Number(e.balance).toFixed(2)}` : ""}</p>
              </div>
              <span className={`rounded-md border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.1em] ${STATUS_STYLE[e.status] || STATUS_STYLE.mocked}`}>
                {e.status === "skipped_rebooked" ? "skipped · rebooked" : e.status === "mocked" ? "not delivered" : e.status}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
